export const overTimeInSeconds = 1200
